import { render, staticRenderFns } from "./AttendingChip.vue?vue&type=template&id=e6b72fe8&"
import script from "./AttendingChip.vue?vue&type=script&lang=js&"
export * from "./AttendingChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports